var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.415 6.293a1.61 1.61 0 1 0 0 3.22 1.61 1.61 0 0 0 0-3.22zm5.902 6.025a6.11 6.11 0 0 0-2.146-.387V4.146H3.146v15.025h8.974c.135.775.415 1.5.81 2.146H3.146A2.146 2.146 0 0 1 1 19.171V4.146C1 2.961 1.96 2 3.146 2h15.025c1.185 0 2.146.96 2.146 2.146v8.172zm-6.254 1.194c-.21.19-.407.394-.59.611h-8.18l3.23-4.308 2.307 3.079 1.385-1.846 1.848 2.464zm3.961-.08v3.007c4.808 0 4.976 5.805 4.976 5.805s-.33-2.488-4.976-2.488v3.006l-4.146-4.664 4.146-4.665z",
    id: "content-request-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#content-request-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentRequest);
export default __webpack_public_path__ + "static/media/content-request.babb878c7c4de60e8b28906e52a402d0.svg";
export { ForwardRef as ReactComponent };